export const POPULAR_TLDS_STRING: string = [
  // Multi-part ccTLDs - first since they are more specific
  'co\\.il',
  'org\\.il',
  'net\\.il',
  'co\\.uk',
  'org\\.uk',
  'me\\.uk',
  'ac\\.uk',
  'gov\\.uk',
  'com\\.au',
  'net\\.au',
  'org\\.au',
  'co\\.in',
  'org\\.in',
  'net\\.in',
  'com\\.br',
  'net\\.br',
  'org\\.br',
  'com\\.pl',
  'net\\.pl',
  'org\\.pl',
  'co\\.nz',
  'org\\.nz',
  'com\\.mx',
  'org\\.mx',
  'net\\.mx',
  'co\\.cl',
  'org\\.cl',
  'com\\.ch',
  'org\\.ch',
  'co\\.za',
  'org\\.za',
  'co\\.dk',
  'co\\.nl',
  'com\\.be',
  'org\\.be',
  'com\\.ru',
  'org\\.ru',
  'co\\.no',
  'org\\.no',
  'co\\.fi',
  'org\\.fi',
  'co\\.ie',
  'com\\.ar',
  'org\\.ar',
  // Single-part ccTLDs
  'us',
  'ca',
  'uk',
  'de',
  'jp',
  'fr',
  'au',
  'ru',
  'cn',
  'br',
  'es',
  'it',
  'nl',
  'se',
  'ch',
  'in',
  'mx',
  'za',
  'sg',
  'pl',
  'ar',
  'kr',
  'tr',
  'vn',
  'be',
  // Common gTLDs & New gTLDs
  'com',
  'org',
  'net',
  'edu',
  'gov',
  'mil',
  'int',
  'io',
  'ai',
  'co',
  'tv',
  'me',
  'xyz',
  'info',
  'biz',
  'app',
  'dev',
  'tech',
  'shop',
  'store',
  'design',
  'site',
  'online',
  'art',
  'blog',
  'cloud',
  'life',
  'news',
  'media',
  'guru',
].join('|');
